module.exports = " <item-form :label=label :icon=icon :no-empty=\"value ? true : false\"> <div class=vc-date-select> <div class=vc-date-select-text @click=showSelect() :class=\"{'placeholder': !value}\">{{value || placeholder}}</div> <icon value=insert_invitation @click=showSelect()></icon> <overlay v-if=show fixed @click=hideSelect></overlay> <date-picker @date-select-cancel=hideSelect :type=type :format=format :limit=limit @date-select-sure=select v-if=show :time=value></date-picker> </div>  </item-form>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/forms/dateSelect.vue
 ** module id = 438
 ** module chunks = 1
 **/